import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const Wrapper = styled('div')({
  position: 'relative',
  [media('xs')]: {
    marginBottom: 30
  },
  [media('lg')]: {
    marginBottom: 0
  }
});

export default Wrapper;
